<template>
  <div id="app">
    <game></game>
  </div>
</template>
<script>
import game from './components/game'

export default {
  name: 'app',
  components: {
    game
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?6999b7b4